export default class Header {
    constructor() {
        this.header = document.querySelector('.header');
        this.emiratesLogo = document.querySelector('.header__emirates');
        this.headerUrbanDaddy = document.querySelector('.header__urbandaddy');
        this.$presentsOnExcuse = $('.header__presents--excuse');
        this.$logoUdBlack = $('.logo__ud--black');
        this.$logoUdWhite = $('.logo__ud--white');
        this.$logoUrbanDaddyHome = $('.logo__urbandaddy--home');
        this.$logoUrbanDaddyExcuse = $('.logo__urbandaddy--excuse');
        this.$cloud = $('.cloud');
    }

    toggleUrbanDaddyLogo() {
        if ($(window).width() < 767) {
            this.headerUrbanDaddy.classList.remove('hide');
        } else {
            this.headerUrbanDaddy.classList.add('hide');
        }
    }

    enterHomeState() {
        this.header.classList.add('header__home');
        $(window).on('resize', this.toggleUrbanDaddyLogo.bind(this));
        $(window).trigger('resize');
        this.$logoUdBlack.addClass('hide');
        this.$logoUdWhite.removeClass('hide');
        this.$cloud.addClass('hide');

        this.$logoUrbanDaddyHome.removeClass('hide');
        this.$logoUrbanDaddyExcuse.addClass('hide');
    }

    leaveHomeState() {
        $(window).off('resize', this.toggerUrbanDaddyLogo);
        this.header.classList.remove('header__home');
        this.headerUrbanDaddy.classList.remove('hide');

        this.$logoUrbanDaddyExcuse.removeClass('hide');
        this.$logoUrbanDaddyHome.addClass('hide');
    }

    enterExcuseState() {
        $(window).off('resize', this.toggerUrbanDaddyLogo);
        this.$presentsOnExcuse.addClass('hide');
        this.headerUrbanDaddy.classList.add('header__item--right');
        this.headerUrbanDaddy.classList.remove('hide');
        this.$logoUdBlack.removeClass('hide');
        this.$logoUdWhite.addClass('hide');
        this.$cloud.removeClass('hide');

        this.$logoUrbanDaddyExcuse.removeClass('hide');
        this.$logoUrbanDaddyHome.addClass('hide');
    }

    leaveExcuseState() {
        this.$presentsOnExcuse.removeClass('hide');
        this.headerUrbanDaddy.classList.remove('header__item--right');

        this.$logoUrbanDaddyExcuse.addClass('hide');
        this.$logoUrbanDaddyHome.removeClass('hide');
    }
}



// WEBPACK FOOTER //
// ./frontend/js/modules/header.js